type TTimerMinutesRender = {
  hours: number;
  minutes: number;
  seconds: number;
};

export const timerMinutesRender = ({
  hours,
  minutes,
  seconds,
}: TTimerMinutesRender) =>
  `${(hours * 60 + minutes).toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
